<template>
  <div class="modal fade" tabindex="-1" role="dialog" v-on:keyup.enter="create">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">New Case</h4>
      </div>
      <div class="modal-body">
        <form class="form-horizontal" submit="#"
          <div class="form-group" v-bind:class="{ 'has-error': errors.name === true}" >
            <label class="control-label col-sm-3">Case name</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" placeholder="Syria - May 2018" v-model="name"/>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
        <button v-on:click="create"type="button" class="btn btn-danger">Create</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div>
</template>

<script>
  export default {
    name: 'NewCaseModal',
    data () {
      return {
        name: null,
        errors: {
          name: false
        }
      }
    },
    methods: {
      create () {
        if (this.name !== null && this.name !== '') {
          this.errors.name = false
          window.jQuery('#NewCaseModal').modal('hide')
          this.$emit('create', this.name)
          this.name = null
        } else {
          this.errors.name = true
        }
        console.log(this.errors)
      }
    }
  }
  
</script>



// WEBPACK FOOTER //
// NewCaseModal.vue?245f531a